import { render } from "./ProgressChart.vue?vue&type=template&id=756a2dac&scoped=true"
import script from "./ProgressChart.vue?vue&type=script&lang=js"
export * from "./ProgressChart.vue?vue&type=script&lang=js"

import "./ProgressChart.vue?vue&type=style&index=0&id=756a2dac&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/vitamins/koningsnvteaching/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756a2dac"]])

export default __exports__